export const GA_MEASUREMENT_ID = 'G-JS0HKJFYC7';
export const CONSENT_STORAGE_KEY = 'cookie_consent_analytics';

export type ConsentStatus = 'accepted' | 'declined';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function ensureGtag(): void {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = (...args: unknown[]) => {
      window.dataLayer.push(args);
    };
  }
}

export function getStoredConsent(): ConsentStatus | null {
  const value = localStorage.getItem(CONSENT_STORAGE_KEY);
  if (value === 'accepted' || value === 'declined') {
    return value;
  }
  return null;
}

export function storeConsent(status: ConsentStatus): void {
  localStorage.setItem(CONSENT_STORAGE_KEY, status);
}

export function grantAnalyticsConsent(): void {
  ensureGtag();
  window.gtag('consent', 'update', {
    analytics_storage: 'granted',
  });
}

export function denyAnalyticsConsent(): void {
  ensureGtag();
  window.gtag('consent', 'update', {
    analytics_storage: 'denied',
  });
}

export function loadGoogleAnalytics(): void {
  ensureGtag();
  grantAnalyticsConsent();

  const existingScript = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`
  );

  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
}

export function applyStoredConsent(): void {
  const consent = getStoredConsent();
  if (consent === 'accepted') {
    loadGoogleAnalytics();
  } else if (consent === 'declined') {
    denyAnalyticsConsent();
  }
}
